import { useNavigate } from 'react-router-dom-v6'

import { OAuthClientForm } from '../components/OAuthClientForm'
import { useRegisterOAuthClient } from '../hooks'
import type { OAuthClientInput } from '../types'

export function RegisterOAuthClient() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterOAuthClient()

  const onSubmit = async (input: OAuthClientInput) => {
    await register(input)
    navigate('/apis')
  }

  return <OAuthClientForm mode="create" onSubmit={onSubmit} />
}
